import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import PaymentsList from './PaymentsList';
import { currencyFormatter } from '../../utils/helpers';

const CollapsePanel = Collapse.Panel;

const PaymentsCollapse = ({ visible, handleModalCancel, showReturnOverpayModal, loanId, payments, t, isAdmin, loanPaid, returnOverpay, account, fullAccountName, onShiftPayment, role, amountEarlyFee }) => {

  return (
    <Collapse>
      <CollapsePanel header={t('Zobraziť platby')}>
        <PaymentsList visible={visible} handleModalCancel={handleModalCancel} showReturnOverpayModal={showReturnOverpayModal}
          loanId={loanId} payments={payments} isAdmin={isAdmin} loanPaid={loanPaid} returnOverpay={returnOverpay} account={account}
          fullAccountName={fullAccountName} onShiftPayment={onShiftPayment} role={role} amountEarlyFee={amountEarlyFee} />
      </CollapsePanel>
    </Collapse>
  )

};

PaymentsCollapse.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleModalCancel: PropTypes.func.isRequired,
  showReturnOverpayModal: PropTypes.func.isRequired,
  loanId: PropTypes.string,
  payments: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  loanPaid: PropTypes.bool.isRequired,
  returnOverpay: PropTypes.func
};

export default translate()(PaymentsCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/PaymentsCollapse.js